import type { GetRoutesRequest, Stops, Route, RouteResponse } from '../types/RouteOptimization';
import { api } from './api';

export const routeApi = api.injectEndpoints({
  endpoints: builder => ({
    getRoutes: builder.query<RouteResponse, GetRoutesRequest>({
      query: ({ page, pageSize }) => {
        const params = new URLSearchParams();

        if (page) params.set('page', String(page));
        if (pageSize) params.set('page_size', String(pageSize));

        return `routes/?${params.toString()}`;
      },
      providesTags: ['Routes'],
    }),
    getStops: builder.query<Stops[], string>({
      query: routeId => {
        return `stops/${routeId}/`;
      },
    }),
    getRoute: builder.query<Route, string>({
      query: id => ({
        url: `route-get/${id}/`,
        method: 'GET',
      }),
    }),
    createRoute: builder.mutation<void, Route>({
      query: Route => ({
        url: 'create-route/',
        method: 'POST',
        body: Route,
      }),
      invalidatesTags: ['Routes'],
    }),
    editRoute: builder.mutation<Route, Partial<Route>>({
      query: route => ({
        url: `route/${route.id}/`,
        method: 'PUT',
        body: route,
      }),
      invalidatesTags: ['Routes'],
    }),
    deleteRoute: builder.mutation<void, string>({
      query: id => ({
        url: `route/${id}/`,
        method: 'DELETE',
      }),
    }),
  }),
});

export const {
  useLazyGetRoutesQuery,
  useLazyGetStopsQuery,
  useLazyGetRouteQuery,
  useCreateRouteMutation,
  useEditRouteMutation,
  useDeleteRouteMutation,
} = routeApi;
